import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Icon, Layout, Avatar, Menu, Dropdown, message } from "antd";
import { logout } from "@/store/actions";
import Hamburger from "@/components/Hamburger";
import BreadCrumb from "@/components/BreadCrumb";
import "./index.less";
import { useHistory } from "react-router-dom";
import tokenManager from "@/utils/tokenManager";
import { getToken } from "@/utils/auth";

const { Header } = Layout;

const LayoutHeader = (props) => {
  const {
    role,
    name,
    sidebarCollapsed,
    logout,
    fixedHeader,
  } = props;
  const history = useHistory();
  const [timeRemaining, setTimeRemaining] = useState('');

  // 更新剩余时间
  useEffect(() => {
    const updateTimeRemaining = () => {
      const token = getToken();
      if (token) {
        const tokenInfo = tokenManager.getTokenInfo();
        if (tokenInfo) {
          setTimeRemaining(tokenInfo.timeRemainingFormatted);
        }
      }
    };

    // 初始更新
    updateTimeRemaining();

    // 每分钟更新一次
    const timer = setInterval(updateTimeRemaining, 60000);

    return () => clearInterval(timer);
  }, []);

  const handleLogout = () => {
    logout();
    message.success("退出登录成功");
    // 延迟跳转，让用户看到消息
    setTimeout(() => {
      history.push("/login");
    }, 1000);
  };

  const computedStyle = () => {
    let styles;
    if (fixedHeader) {
      if (sidebarCollapsed) {
        styles = {
          width: "calc(100% - 80px)",
        };
      } else {
        styles = {
          width: "calc(100% - 200px)",
        };
      }
    } else {
      styles = {
        width: "100%",
      };
    }
    return styles;
  };

  const menu = (
    <Menu>
      <Menu.Item key="profile">
        <Icon type="user" />
        个人信息
      </Menu.Item>
      <Menu.Item key="settings">
        <Icon type="setting" />
        设置
      </Menu.Item>
      <Menu.Divider />
      <Menu.Item key="logout" onClick={handleLogout}>
        <Icon type="logout" />
        退出登录
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      {fixedHeader ? <Header /> : null}
      <Header
        style={computedStyle()}
        className={fixedHeader ? "fix-header" : ""}
      >
        <Hamburger />
        <BreadCrumb />
        <div className="right-menu">
          {timeRemaining && (
            <div className="token-time">
              <Icon type="clock-circle" style={{ marginRight: 5 }} />
              <span>登录剩余时间: {timeRemaining}</span>
            </div>
          )}
          <div className="dropdown-wrap">
            <Dropdown overlay={menu} placement="bottomRight">
              <span className="user-info">
                <Avatar size="small" icon="user" />
                <span className="username">{name || "用户"}</span>
                <Icon type="down" />
              </span>
            </Dropdown>
          </div>
        </div>
      </Header>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.app,
    ...state.user,
    ...state.settings,
  };
};

export default connect(mapStateToProps, { logout })(LayoutHeader);
